import React, { useId } from "react";

export function DeviceArrowIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z"
        fill="#737373"
      />
      <path
        d="M12 25l8-8m0 0h-6m6 0v6"
        stroke="#171717"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
    </svg>
  )
}

export function DeviceCardsIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  const id = useId()

  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z"
        fill="#737373"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2zm0 6a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2zm1 5a1 1 0 00-1 1v2a1 1 0 001 1h12a1 1 0 001-1v-2a1 1 0 00-1-1H10z"
        fill={`url(#${id}-gradient)`}
      />
      <rect x={9} y={6} width={14} height={4} rx={1} fill="#171717" />
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
      <defs>
        <linearGradient
          id={`${id}-gradient`}
          x1={16}
          y1={12}
          x2={16}
          y2={28}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#737373" />
          <stop offset={1} stopColor="#737373" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function DeviceClockIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4a4 4 0 014-4h14a4 4 0 014 4v10h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h5v2H9a4 4 0 01-4-4V4z"
        fill="#737373"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 32a8 8 0 100-16 8 8 0 000 16zm1-8.414V19h-2v5.414l4 4L28.414 27 25 23.586z"
        fill="#171717"
      />
    </svg>
  )
}

export function DeviceListIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z"
        fill="#737373"
      />
      <circle cx={11} cy={14} r={2} fill="#171717" />
      <circle cx={11} cy={20} r={2} fill="#171717" />
      <circle cx={11} cy={26} r={2} fill="#171717" />
      <path
        d="M16 14h6M16 20h6M16 26h6"
        stroke="#737373"
        strokeWidth={2}
        strokeLinecap="square"
      />
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
    </svg>
  )
}

export function DeviceLockIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4a4 4 0 014-4h14a4 4 0 014 4v10h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h5v2H9a4 4 0 01-4-4V4z"
        fill="#737373"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 19.5a3.5 3.5 0 117 0V22a2 2 0 012 2v6a2 2 0 01-2 2h-7a2 2 0 01-2-2v-6a2 2 0 012-2v-2.5zm2 2.5h3v-2.5a1.5 1.5 0 00-3 0V22z"
        fill="#171717"
      />
    </svg>
  )
}

export function DeviceChartIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z"
        fill="#737373"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 13.838V26a2 2 0 01-2 2H11a2 2 0 01-2-2V15.65l2.57 3.212a1 1 0 001.38.175L15.4 17.2a1 1 0 011.494.353l1.841 3.681c.399.797 1.562.714 1.843-.13L23 13.837z"
        fill="#171717"
      />
      <path
        d="M10 12h12"
        stroke="#737373"
        strokeWidth={2}
        strokeLinecap="square"
      />
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
    </svg>
  )
}

export function DeviceUserIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 23a3 3 0 100-6 3 3 0 000 6zm-1 2a4 4 0 00-4 4v1a2 2 0 002 2h6a2 2 0 002-2v-1a4 4 0 00-4-4h-2z"
        fill="#737373"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4a4 4 0 014-4h14a4 4 0 014 4v24a4.002 4.002 0 01-3.01 3.877c-.535.136-.99-.325-.99-.877s.474-.98.959-1.244A2 2 0 0025 28V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 001.041 1.756C8.525 30.02 9 30.448 9 31s-.455 1.013-.99.877A4.002 4.002 0 015 28V4z"
        fill="#A3A3A3"
      />
    </svg>
  )
}

export function DeviceNotificationIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z"
        fill="#A3A3A3"
      />
      <path
        d="M9 8a2 2 0 012-2h10a2 2 0 012 2v2a2 2 0 01-2 2H11a2 2 0 01-2-2V8z"
        fill="#737373"
      />
    </svg>
  )
}

export function DeviceTouchIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  const id = useId()

  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
      <defs>
        <linearGradient
          id={`${id}-gradient`}
          x1={14}
          y1={14.5}
          x2={7}
          y2={17}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#737373" />
          <stop offset={1} stopColor="#D4D4D4" stopOpacity={0} />
        </linearGradient>
      </defs>
      <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4a4 4 0 014-4h14a4 4 0 014 4v13h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h4v2H9a4 4 0 01-4-4V4z"
        fill="#A3A3A3"
      />
      <path
        d="M7 22c0-4.694 3.5-8 8-8"
        stroke={`url(#${id}-gradient)`}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 20l.217-5.513a1.431 1.431 0 00-2.85-.226L17.5 21.5l-1.51-1.51a2.107 2.107 0 00-2.98 0 .024.024 0 00-.005.024l3.083 9.25A4 4 0 0019.883 32H25a4 4 0 004-4v-5a3 3 0 00-3-3h-5z"
        fill="#A3A3A3"
      />
    </svg>
  )
}

export function LogoIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="180" height="60" viewBox="0 0 741.085 137.75" {...props}>
      <path
        d="m170.415 28.692 14.95.11v30.45h35.35v-30.45h14.95v76.38h-14.95v-32.19h-35.35v32.3l-14.95-.11zm77.8 61.11c0-11.57 8.07-17.57 22.04-17.57h12.76c-.98-6.87-4.14-10.69-10.36-10.69-4.69 0-8.4 1.85-10.91 6.22l-12.11-4.26c3.16-6.98 10.14-14.18 23.24-14.18 16.25 0 24.33 9.05 24.33 25.75v30.11h-13.42l-.11-5.89c-3.06 4.69-7.86 7.2-14.84 7.2-13.09 0-20.62-6-20.62-16.69zm35.13-6.99h.11v-.32h-8.62c-9.6 0-12.77 2.61-12.77 6.87 0 3.6 3.28 5.67 8.84 5.67 7.2 0 12.44-6 12.44-12.22zm25.2-32.18h13.53l.66 7.31c3.6-5.68 9.16-8.62 15.93-8.62 13.2 0 20.51 7.96 20.4 24.65v31.21h-14.4v-27.93c0-11.02-4.04-14.3-10.15-14.4-7.53-.11-11.56 4.69-11.56 13.74v28.59h-14.41zm59.03 27.27c0-17.45 9.6-28.58 24.66-28.58 7.2 0 12.77 3.05 16.37 8.62v-29.14h14.4v76.38h-13.64l-.54-7.53c-3.6 5.68-9.28 8.84-16.59 8.84-15.06 0-24.66-11.13-24.66-28.59zm41.03 1.64v-3.27c-.66-8.19-5.68-13.64-12.77-13.64-7.74 0-13.31 6.33-13.31 15.27 0 8.95 5.67 15.39 13.42 15.39 6.98 0 12-5.57 12.66-13.75zm24.11 13.53 11.68-5.35c2.18 3.6 6.21 6.44 11.34 6.44 5.02 0 8.08-1.42 8.08-4.36 0-2.84-2.51-4.04-6.33-5.02l-5.13-1.31c-10.47-2.73-16.8-9.06-16.8-16.81 0-11.02 7.42-17.34 20.73-17.34 10.04 0 18.77 4.91 21.27 12l-11.34 5.13c-1.09-3.06-5.79-4.91-10.04-4.91-4.15 0-6.66 1.85-6.66 4.91 0 1.96 2.29 3.38 6.33 4.36l6.88 1.75c10.69 2.61 14.94 10.58 14.94 17.45 0 9.93-9.16 16.48-21.82 16.48-10.8 0-19.42-5.02-23.13-13.42zm54.45-64.92h14.4v29.46c3.6-5.35 9.16-8.29 15.82-8.29 13.31 0 20.62 7.96 20.51 24.65v31.21h-14.4v-27.93c0-11.02-4.15-14.3-10.26-14.4-7.42-.11-11.56 4.69-11.56 13.74v28.59h-14.4zm60.22 61.65c0-11.57 8.08-17.57 22.04-17.57h12.77c-.98-6.87-4.15-10.69-10.37-10.69-4.69 0-8.4 1.85-10.91 6.22l-12.11-4.26c3.17-6.98 10.15-14.18 23.24-14.18 16.26 0 24.33 9.05 24.33 25.75v30.11h-13.42l-.11-5.89c-3.05 4.69-7.85 7.2-14.83 7.2-13.1 0-20.63-6-20.63-16.69zm35.14-6.99h.11v-.32h-8.62c-9.6 0-12.77 2.61-12.77 6.87 0 3.6 3.27 5.67 8.84 5.67 7.2 0 12.44-6 12.44-12.22zm25.2-54.01h14.4v42.34l18.66-20.51h17.13l-20.62 23.02 22.26 31.53h-16.91l-14.62-21.17-5.9 6.66v14.51h-14.4zm53.9 49.1c0-16.8 11.68-28.58 28.15-28.58 14.19 0 26.41 11.67 26.41 32.07h-39.83c1.2 8.19 6.98 12.55 14.19 12.55 5.89 0 9.49-2.94 11.67-7.09l12.66 5.02c-4.59 9.16-13.1 14.62-25.75 14.62-16.15 0-27.5-11.78-27.5-28.59zm15.39-7.2h24c-1.96-6.55-6.22-9.27-11.78-9.27-6.33 0-10.48 3.05-12.22 9.27zM719.933 38.675c0-5.86 4.75-10.61 10.61-10.61 5.85 0 10.6 4.75 10.6 10.61 0 5.86-4.75 10.61-10.6 10.61-5.86 0-10.61-4.75-10.61-10.61zm19.07 0c0-5.03-3.52-8.55-8.46-8.55-4.95 0-8.47 3.52-8.47 8.55 0 5.03 3.52 8.55 8.47 8.55 4.94 0 8.46-3.52 8.46-8.55zm-12.42-5.9h4.04c2.33 0 3.99 1.51 3.99 3.64 0 1.51-.91 2.73-2.29 3.29l2.77 4.63h-2.1l-2.45-4.28h-2.1v4.28h-1.86zm4.15 5.54c1.11 0 1.98-.79 1.98-1.9 0-1.14-.87-1.94-2.17-1.94h-2.1v3.84z"
        style={{
          stroke: '#c1c1c1',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeDashoffset: 0,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1
        }}

      />
      <g transform="matrix(.29874 0 0 .29874 68.805 68.797)">
        <linearGradient id="a" x1="0" x2="1" y1=".5" y2=".5" gradientUnits="objectBoundingBox">
          <stop offset="0%"

                style={{
                  stopColor: '#5454ff',
                  stopOpacity: 1
                }}
          />
          <stop offset="100%"
                style={{
                  stopColor: '#ff73ff',
                  stopOpacity: 1


                }}

          />
        </linearGradient>
        <path
          d="M230.78-.015c0 29.72-28.27 53.6-39 79.44-11.09 26.78-8.41 63.56-28.56 83.78s-57 17.5-83.75 28.61c-25.84 10.71-49.72 39-79.44 39s-53.6-28.27-79.44-39c-26.78-11.11-63.56-8.43-83.75-28.61-20.19-20.18-17.53-57-28.62-83.78-10.73-25.84-39-49.72-39-79.44s28.27-53.6 39-79.44c11.11-26.78 8.43-63.56 28.61-83.75 20.18-20.19 57-17.5 83.75-28.61 25.84-10.71 49.73-39 79.44-39s53.6 28.27 79.44 39c26.76 11.11 63.54 8.43 83.76 28.61 20.22 20.18 17.5 57 28.61 83.75 10.68 25.84 38.95 49.73 38.95 79.44z"
          style={{
            stroke: '#c1c1c1',
            strokeWidth: 0,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'url(#a)',
            fillRule: 'nonzero',
            opacity: 1
          }}
        />
      </g>
      <path d="m43.51 39.02 13.57.08v21.96h23.45V39.1H94.1v57.58H80.53V73.57H57.08v23.19l-13.57-.08z"

            style={{
              stroke: '#c1c1c1',
              strokeWidth: 0,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeDashoffset: 0,
              strokeLinejoin: 'miter',
              strokeMiterlimit: 4,
              fill: '#230736',
              fillRule: 'nonzero',
              opacity: 1
            }}
      />
    </svg>
  )
}

export function MenuIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M5 6h14M5 18h14M5 12h14"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UserIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M15 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.696 19h10.608c1.175 0 2.08-.935 1.532-1.897C18.028 15.69 16.187 14 12 14s-6.028 1.689-6.836 3.103C4.616 18.065 5.521 19 6.696 19Z"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StarIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path
        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  )
}

export function CheckIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path
        d="M9.307 12.248a.75.75 0 1 0-1.114 1.004l1.114-1.004ZM11 15.25l-.557.502a.75.75 0 0 0 1.15-.043L11 15.25Zm4.844-5.041a.75.75 0 0 0-1.188-.918l1.188.918Zm-7.651 3.043 2.25 2.5 1.114-1.004-2.25-2.5-1.114 1.004Zm3.4 2.457 4.25-5.5-1.187-.918-4.25 5.5 1.188.918Z"
        fill="currentColor"
      />
      <circle
        cx="12"
        cy="12"
        r="8.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PlayIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="11.5" stroke="#D4D4D4" />
      <path
        d="M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z"
        fill="#A3A3A3"
        stroke="#A3A3A3"
      />
    </svg>
  )
}

export function ChevronUpIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M17 14l-5-5-5 5"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function QrCodeBorderIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 96 96" fill="none" aria-hidden="true" {...props}>
      <path
        d="M1 17V9a8 8 0 0 1 8-8h8M95 17V9a8 8 0 0 0-8-8h-8M1 79v8a8 8 0 0 0 8 8h8M95 79v8a8 8 0 0 1-8 8h-8"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function LogomarkIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 137.77 137.75" {...props}>
      <g transform="matrix(.29874 0 0 .29874 68.805 68.797)">
        <linearGradient id="a" x1="0" x2="1" y1=".5" y2=".5" gradientUnits="objectBoundingBox">
          <stop offset="0%"
                style={{
                  stopColor: '#5454ff',
                  stopOpacity: 1
                }}

          />
          <stop offset="100%"
                style={{
                  stopColor: '#ff73ff',
                  stopOpacity: 1

                }}
          />
        </linearGradient>
        <path
          d="M230.78-.015c0 29.72-28.27 53.6-39 79.44-11.09 26.78-8.41 63.56-28.56 83.78s-57 17.5-83.75 28.61c-25.84 10.71-49.72 39-79.44 39s-53.6-28.27-79.44-39c-26.78-11.11-63.56-8.43-83.75-28.61-20.19-20.18-17.53-57-28.62-83.78-10.73-25.84-39-49.72-39-79.44s28.27-53.6 39-79.44c11.11-26.78 8.43-63.56 28.61-83.75 20.18-20.19 57-17.5 83.75-28.61 25.84-10.71 49.73-39 79.44-39s53.6 28.27 79.44 39c26.76 11.11 63.54 8.43 83.76 28.61 20.22 20.18 17.5 57 28.61 83.75 10.68 25.84 38.95 49.73 38.95 79.44z"
          style={{
            stroke: '#c1c1c1',
            strokeWidth: 0,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'url(#a)',
            fillRule: 'nonzero',
            opacity: 1

          }}
        />
      </g>
      <path d="m43.51 39.02 13.57.08v21.96h23.45V39.1H94.1v57.58H80.53V73.57H57.08v23.19l-13.57-.08z"
            style={{
              stroke: '#c1c1c1',
              strokeWidth: 0,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeDashoffset: 0,
              strokeLinejoin: 'miter',
              strokeMiterlimit: 4,
              fill: '#230736',
              fillRule: 'nonzero',
              opacity: 1
            }}
      />
    </svg>
  )
}

export function LogoWithLogomark(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="180" height="60" viewBox="0 0 741.085 137.75" {...props}>
      <path
        d="m170.415 28.692 14.95.11v30.45h35.35v-30.45h14.95v76.38h-14.95v-32.19h-35.35v32.3l-14.95-.11zm77.8 61.11c0-11.57 8.07-17.57 22.04-17.57h12.76c-.98-6.87-4.14-10.69-10.36-10.69-4.69 0-8.4 1.85-10.91 6.22l-12.11-4.26c3.16-6.98 10.14-14.18 23.24-14.18 16.25 0 24.33 9.05 24.33 25.75v30.11h-13.42l-.11-5.89c-3.06 4.69-7.86 7.2-14.84 7.2-13.09 0-20.62-6-20.62-16.69zm35.13-6.99h.11v-.32h-8.62c-9.6 0-12.77 2.61-12.77 6.87 0 3.6 3.28 5.67 8.84 5.67 7.2 0 12.44-6 12.44-12.22zm25.2-32.18h13.53l.66 7.31c3.6-5.68 9.16-8.62 15.93-8.62 13.2 0 20.51 7.96 20.4 24.65v31.21h-14.4v-27.93c0-11.02-4.04-14.3-10.15-14.4-7.53-.11-11.56 4.69-11.56 13.74v28.59h-14.41zm59.03 27.27c0-17.45 9.6-28.58 24.66-28.58 7.2 0 12.77 3.05 16.37 8.62v-29.14h14.4v76.38h-13.64l-.54-7.53c-3.6 5.68-9.28 8.84-16.59 8.84-15.06 0-24.66-11.13-24.66-28.59zm41.03 1.64v-3.27c-.66-8.19-5.68-13.64-12.77-13.64-7.74 0-13.31 6.33-13.31 15.27 0 8.95 5.67 15.39 13.42 15.39 6.98 0 12-5.57 12.66-13.75zm24.11 13.53 11.68-5.35c2.18 3.6 6.21 6.44 11.34 6.44 5.02 0 8.08-1.42 8.08-4.36 0-2.84-2.51-4.04-6.33-5.02l-5.13-1.31c-10.47-2.73-16.8-9.06-16.8-16.81 0-11.02 7.42-17.34 20.73-17.34 10.04 0 18.77 4.91 21.27 12l-11.34 5.13c-1.09-3.06-5.79-4.91-10.04-4.91-4.15 0-6.66 1.85-6.66 4.91 0 1.96 2.29 3.38 6.33 4.36l6.88 1.75c10.69 2.61 14.94 10.58 14.94 17.45 0 9.93-9.16 16.48-21.82 16.48-10.8 0-19.42-5.02-23.13-13.42zm54.45-64.92h14.4v29.46c3.6-5.35 9.16-8.29 15.82-8.29 13.31 0 20.62 7.96 20.51 24.65v31.21h-14.4v-27.93c0-11.02-4.15-14.3-10.26-14.4-7.42-.11-11.56 4.69-11.56 13.74v28.59h-14.4zm60.22 61.65c0-11.57 8.08-17.57 22.04-17.57h12.77c-.98-6.87-4.15-10.69-10.37-10.69-4.69 0-8.4 1.85-10.91 6.22l-12.11-4.26c3.17-6.98 10.15-14.18 23.24-14.18 16.26 0 24.33 9.05 24.33 25.75v30.11h-13.42l-.11-5.89c-3.05 4.69-7.85 7.2-14.83 7.2-13.1 0-20.63-6-20.63-16.69zm35.14-6.99h.11v-.32h-8.62c-9.6 0-12.77 2.61-12.77 6.87 0 3.6 3.27 5.67 8.84 5.67 7.2 0 12.44-6 12.44-12.22zm25.2-54.01h14.4v42.34l18.66-20.51h17.13l-20.62 23.02 22.26 31.53h-16.91l-14.62-21.17-5.9 6.66v14.51h-14.4zm53.9 49.1c0-16.8 11.68-28.58 28.15-28.58 14.19 0 26.41 11.67 26.41 32.07h-39.83c1.2 8.19 6.98 12.55 14.19 12.55 5.89 0 9.49-2.94 11.67-7.09l12.66 5.02c-4.59 9.16-13.1 14.62-25.75 14.62-16.15 0-27.5-11.78-27.5-28.59zm15.39-7.2h24c-1.96-6.55-6.22-9.27-11.78-9.27-6.33 0-10.48 3.05-12.22 9.27zM719.933 38.675c0-5.86 4.75-10.61 10.61-10.61 5.85 0 10.6 4.75 10.6 10.61 0 5.86-4.75 10.61-10.6 10.61-5.86 0-10.61-4.75-10.61-10.61zm19.07 0c0-5.03-3.52-8.55-8.46-8.55-4.95 0-8.47 3.52-8.47 8.55 0 5.03 3.52 8.55 8.47 8.55 4.94 0 8.46-3.52 8.46-8.55zm-12.42-5.9h4.04c2.33 0 3.99 1.51 3.99 3.64 0 1.51-.91 2.73-2.29 3.29l2.77 4.63h-2.1l-2.45-4.28h-2.1v4.28h-1.86zm4.15 5.54c1.11 0 1.98-.79 1.98-1.9 0-1.14-.87-1.94-2.17-1.94h-2.1v3.84z"
        style={{
          stroke: '#c1c1c1',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeDashoffset: 0,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          fill: '#230736',
          fillRule: 'nonzero',
          opacity: 1
        }}

      />
      <g transform="matrix(.29874 0 0 .29874 68.805 68.797)">
        <linearGradient id="a" x1="0" x2="1" y1=".5" y2=".5" gradientUnits="objectBoundingBox">
          <stop offset="0%"

                style={{
                  stopColor: '#5454ff',
                  stopOpacity: 1
                }}
          />
          <stop offset="100%"
                style={{
                  stopColor: '#ff73ff',
                  stopOpacity: 1


                }}

          />
        </linearGradient>
        <path
          d="M230.78-.015c0 29.72-28.27 53.6-39 79.44-11.09 26.78-8.41 63.56-28.56 83.78s-57 17.5-83.75 28.61c-25.84 10.71-49.72 39-79.44 39s-53.6-28.27-79.44-39c-26.78-11.11-63.56-8.43-83.75-28.61-20.19-20.18-17.53-57-28.62-83.78-10.73-25.84-39-49.72-39-79.44s28.27-53.6 39-79.44c11.11-26.78 8.43-63.56 28.61-83.75 20.18-20.19 57-17.5 83.75-28.61 25.84-10.71 49.73-39 79.44-39s53.6 28.27 79.44 39c26.76 11.11 63.54 8.43 83.76 28.61 20.22 20.18 17.5 57 28.61 83.75 10.68 25.84 38.95 49.73 38.95 79.44z"

          style={{
            stroke: '#c1c1c1',
            strokeWidth: 0,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'url(#a)',
            fillRule: 'nonzero',
            opacity: 1

          }}
        />
      </g>
      <path d="m43.51 39.02 13.57.08v21.96h23.45V39.1H94.1v57.58H80.53V73.57H57.08v23.19l-13.57-.08z"

            style={{

              stroke: '#c1c1c1',
              strokeWidth: 0,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeDashoffset: 0,
              strokeLinejoin: 'miter',
              strokeMiterlimit: 4,
              fill: '#230736',
              fillRule: 'nonzero',
              opacity: 1
            }}
      />
    </svg>
  )
}

export function PlaceholderFrame(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 366 729" aria-hidden="true" {...props}>
      <path
        fill="#F2F2F2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M300.092 1c41.22 0 63.223 21.99 63.223 63.213V184.94c-.173.184-.329.476-.458.851.188-.282.404-.547.647-.791.844-.073 2.496.257 2.496 2.157V268.719c-.406 2.023-2.605 2.023-2.605 2.023a7.119 7.119 0 0 1-.08-.102v394.462c0 41.213-22.001 63.212-63.223 63.212h-95.074c-.881-.468-2.474-.795-4.323-.838l-33.704-.005-.049.001h-.231l-.141-.001c-2.028 0-3.798.339-4.745.843H66.751c-41.223 0-63.223-21.995-63.223-63.208V287.739c-.402-.024-2.165-.23-2.524-2.02v-.973A2.039 2.039 0 0 1 1 284.62v-47.611c0-.042.001-.084.004-.126v-.726c0-1.9 1.652-2.23 2.496-2.157l.028.028v-16.289c-.402-.024-2.165-.23-2.524-2.02v-.973A2.039 2.039 0 0 1 1 214.62v-47.611c0-.042.001-.084.004-.126v-.726c0-1.9 1.652-2.23 2.496-2.157l.028.028v-26.041a2.26 2.26 0 0 0 .093-.236l-.064-.01a3.337 3.337 0 0 1-.72-.12l-.166-.028A2 2 0 0 1 1 135.62v-24.611a2 2 0 0 1 1.671-1.973l.857-.143v-44.68C3.528 22.99 25.53 1 66.75 1h233.341ZM3.952 234.516a5.481 5.481 0 0 0-.229-.278c.082.071.159.163.228.278Zm89.99-206.304A4.213 4.213 0 0 0 89.727 24H56.864C38.714 24 24 38.708 24 56.852v618.296C24 693.292 38.714 708 56.864 708h250.272c18.15 0 32.864-14.708 32.864-32.852V56.852C340 38.708 325.286 24 307.136 24h-32.864a4.212 4.212 0 0 0-4.213 4.212v2.527c0 10.235-8.3 18.532-18.539 18.532H112.48c-10.239 0-18.539-8.297-18.539-18.532v-2.527Z"
      />
      <rect x="154" y="29" width="56" height="5" rx="2.5" fill="#D4D4D4" />
    </svg>
  )
}

export function EmailGradient(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg id="Layer_1"
         viewBox="0 0 35 26"  {...props}>
      <defs>
        <linearGradient id="linear-gradient" x1="3.3" y1="21.59" x2="33.7" y2="3.2" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#5954e4" />
          <stop offset=".19" stopColor="#6453e5" />
          <stop offset=".52" stopColor="#8252ea" />
          <stop offset=".96" stopColor="#b250f2" />
          <stop offset="1" stopColor="#b750f3" />
        </linearGradient>
      </defs>
      <path className="cls-1"
            d="m30.96,0H4.04C1.81,0,0,1.76,0,3.92v18.17c0,2.16,1.81,3.92,4.04,3.92h26.91c2.23,0,4.04-1.76,4.04-3.92V3.92C35,1.76,33.19,0,30.96,0Zm2.89,22.08c0,1.54-1.3,2.8-2.89,2.8H4.04c-1.59,0-2.89-1.26-2.89-2.8V7.56l13.58,8.24c.84.51,1.8.76,2.76.76s1.92-.25,2.76-.76l13.58-8.24v14.52Zm0-15.84l-14.2,8.62c-1.3.79-2.99.79-4.29,0L1.16,6.24v-2.32c0-1.54,1.3-2.8,2.89-2.8h26.91c1.59,0,2.89,1.26,2.89,2.8v2.32Z" />
    </svg>
  )
}
